<template>
  <CModal
    size="lg"
    :show.sync="isModalVisible"
    :closeOnBackdrop="false"
    class="CmodalCustom"
  >
    <div class="container">
      <div v-if="isShow === true">
        <PopupIntroCmodal :isAddQueueShow="isShow" :code="`LKT01-8`" />
      </div>
      <CCardBody class="CustomCmodal">
        <CCol>
          <div v-if="cardType === 'score'">
            <template v-if="CheckWidth <= 500">
              <CRow align-vertical="center" align-horizontal="center">
                <img
                  class="ScrollImage"
                  :src="baseURL + cardContent.content.image[0].url"
                  width="80%"
                  alt="Image text"
                />
                <h2 class="NumbTextMobile mb-5">
                  {{ score }} / {{ maxscore }}
                </h2>
              </CRow>
            </template>
            <template v-else>
              <CRow align-vertical="center" align-horizontal="center">
                <img
                  class="ScrollImage"
                  :src="baseURL + cardContent.content.image[0].url"
                  width="500px"
                  :height="cardContent.heightimg"
                  alt="Image text"
                />
                <h1 class="NumbText mb-5">{{ score }} / {{ maxscore }}</h1>
              </CRow>
            </template>
          </div>

          <div v-else-if="cardType === 'img'">
            <template v-if="CheckWidth <= 500">
              <CRow
                align-vertical="center"
                align-horizontal="center"
                class="mb-3"
              >
                <img
                  :src="baseURL + cardContent.content.item[0].icon.enable.data"
                  width="100%"
                  alt="Image text"
                />
              </CRow>
            </template>
            <template v-else>
              <CRow
                align-vertical="center"
                align-horizontal="center"
                class="mb-3"
              >
                <img
                  :src="baseURL + cardContent.content.item[0].icon.enable.data"
                  width="50%"
                  alt="Image text"
                />
              </CRow>
            </template>
          </div>

          <div v-else-if="cardType === 'flower'">
            <template v-if="CheckWidth <= 500">
              <CRow
                align-vertical="center"
                align-horizontal="center"
                class="mb-3"
              >
                <img
                  :src="baseURL + cardContentFlower"
                  width="100%"
                  alt="Image text"
                />
              </CRow>
            </template>
            <template v-else>
              <CRow
                align-vertical="center"
                align-horizontal="center"
                class="mb-3"
              >
                <!-- {{cardContent.content}} -->
                <img
                  :src="baseURL + cardContentFlower"
                  width="50%"
                  alt="Image text"
                />
              </CRow>
            </template>
          </div>

          <div v-else-if="cardType === 'text'" class="ml-4 mr-4">
            <template v-if="CheckWidth <= 500">
              <CRow
                align-vertical="center"
                align-horizontal="center"
                class="mb-3"
              >
                <img
                  :src="baseURL + cardContent.content.item[0].icon.enable.data"
                  width="100%"
                  alt="Image text"
                />
              </CRow>
            </template>
            <template v-else>
              <CRow
                align-vertical="center"
                align-horizontal="center"
                class="mb-3"
              >
                <img
                  :src="baseURL + cardContent.content.item[0].icon.enable.data"
                  width="50%"
                  alt="Image text"
                />
              </CRow>
            </template>

            <CRow
              align-vertical="center"
              align-horizontal="center"
              class="mb-3 pt-2 pb-2 pl-2 pr-2"
            >
              <h3
                :class="checkLangClass() + ' wordCustom'"
                style="text-align: center !important"
              >
                {{
                  $helpers.translate(cardContent.content.item[0].title, lang)
                }}
              </h3>
            </CRow>
          </div>

          <CRow align-vertical="center" align-horizontal="center">
            <template v-if="cardType === 'flower'">
              <CButton
                @click="checkModal(cardContent)"
                color="success"
                shape="pill"
                size="lg"
                class="ml-2 mr-2 mt-5"
                >{{
                  $helpers.translate(cardContent.navigate.next.title, lang)
                }}</CButton
              >
            </template>
            <template v-else-if="cardType === 'score'">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                "
              >
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    font-size: large;
                    color: white;
                  "
                  v-if="showWarning"
                >
                  <p>
                    {{ scoreStatusText({previousScore, maxscore}) }}
                  </p>
                </div>
                <div style="display: flex; justify-content: center">
                  <CButton
                    @click="linkTo(cardContent)"
                    color="success"
                    shape="pill"
                    size="lg"
                    class="ml-2 mr-2 mt-4"
                    >{{
                      $helpers.translate(cardContent.navigate.next.title, lang)
                    }}</CButton
                  >
                </div>
              </div>
            </template>
            <template v-else>
              <CButton
                @click="linkTo(cardContent)"
                color="success"
                shape="pill"
                size="lg"
                class="ml-2 mr-2 mt-5"
                >{{
                  $helpers.translate(
                    cardContent.content.item[0].navigate.title,
                    lang
                  )
                }}</CButton
              >
            </template>
          </CRow>
        </CCol>
      </CCardBody>
    </div>
  </CModal>
</template>

<script>
import {mapGetters} from 'vuex';
import PopupIntroCModal from './PopupIntroCModal.vue';

export default {
  components: {PopupIntroCModal},
  name: 'CardPopupImg',
  props: {
    setAddQueueVisible: Function,
    cardType: String,
    CardPopupImg: Object,
    cardContent: Object,
    cardContentFlower: String,
    openModal: Function,
    CheckWidth: String,
    isModalVisible: Boolean,
    CheckFirstPage: String,
    score: Number,
    maxscore: Number,
    updateUser: Function,
    showWarning: Boolean,
    previousScore: Number,
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_URL_SOUND,
      lang: this.$store.getters['language/getLanguage'],
      status: true,
      popupData2: {},
      isShow: false,
      code: '',
      startTime: null,
    };
  },

  computed: {
    ...mapGetters({
      getPopUp2: 'template/getPopupData2',
    }),
  },

  watch: {
    getLanguage: function (val) {
      this.lang = val;
    },
    getPopUp2: function (val) {
      this.popupData2 = val;
      this.code = this.cardContent.navigate.next.action;
      this.$emit('popupData2', this.popupData2, this.code);
      this.isModalVisible = false;
      this.isShow = true;
    },
  },

  mounted() {},

  created() {
    this.$store.commit('template/loadingMutation');
    this.status = this.$store.getters['template/loadingGetter'];
    this.lang = this.$store.state.language.language;
    this.startTime = this.$helpers.getDateFormat();
  },

  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    TestModal() {
      this.isAddQueueShow = !this.isAddQueueShow;
    },
    linkTo(path) {
      this.$store.commit('necessary/setScoreToZero');
      if (this.cardType == 'score') {
        this.$store.commit('necessary/setLKAScore', this.score);
      }
      let pathCode = path.codeTemplate.split('-');
      if (
        path.codeTemplate === 'LKS01-2' ||
        path.codeTemplate === 'LKS01-4' ||
        path.codeTemplate === 'LKS01-6' ||
        path.codeTemplate === 'LKS01-11' ||
        path.codeTemplate === 'LKS01-13' ||
        path.codeTemplate === 'LKS01-16' ||
        path.codeTemplate === 'LKS01-18' ||
        path.codeTemplate === 'LKS01-19' ||
        path.codeTemplate === 'LKS01-20' ||
        path.codeTemplate === 'LKS01-23' ||
        path.codeTemplate === 'LKS01-24'
      ) {
        this.$store.commit('score/setDefaultPoint');
      }
      if (pathCode[0] === 'LKS01') {
        this.$store.commit('necessary/setDefaultMode');
      }
      if (path.codeTemplate === 'LKS01-1') {
        //FOR EXERCISE
        const nextAction = path.navigate.next.action;
        this.$emit('updateUser', nextAction);

        // this.$store.dispatch('template/fetchPopUp2', body);
        // let Flw = this.$helpers.setChineseUrl(path.navigate.next.action);
        // this.$router.push(Flw);

        // this.$router.push(`/v4/${splitPath[0]}/${splitPath[1]}`);
      } else if (path.codeTemplate === 'LKS01-2') {
        //for TEST
        const nextAction = path.navigate.next.action;
        // let Flw = this.$helpers.setChineseUrl(path.navigate.next.action);
        this.$emit('updateUser', nextAction);
      } else if (pathCode[0] === 'LKS01') {
        //next for pre test
        // console.log('lks01');
        const nextAction = path.navigate.next.action;
        // const splitPath = nextAction.split('-');
        // let Flw = this.$helpers.setChineseUrl(path.navigate.next.action);
        this.$emit('updateUser', nextAction);
        // this.$router.push(`/v4/${splitPath[0]}/${splitPath[1]}`);
      } else {
        //next when not in if
        let str = path.content.item[0].navigate.action;
        console.log('else card popimg');

        this.$emit('updateUser', str);

        //let Flw = this.$helpers.setChineseUrl(path.content.item[0].navigate.action);
        // let str = path.content.item[0].navigate.action.split('-');
        // let Url = '/' + str[0] + '/' + str[1];
        // this.$store.commit('necessary/setCodePage', str[1]);
        // let body = '/' + str[0] + '/' + str[1];
        // this.$emit('updateUser', body);
        // if (Url == "/IAM01/1") {
        //   this.$router.push(body);
        // } else if (Url == "/IAM01/3") {
        //   this.$router.push(body);
        // } else if (Url == "/CTA04/4") {
        //   this.$router.push(body);
        // } else if (Url == "/CTT04/1") {
        //   this.$router.push(body);
        // } else if (Url == "CTV01/1") {
        //   this.$router.push(body);
        // } else {
        //   this.$router.push(body);
        // }
      }
    },
    checkModal(path) {
      console.log('check Modal cardpopimg');

      //check modal fix ????
      let Flw = this.$helpers.setChineseUrl(path.navigate.next.action);
      if (this.cardType === 'flower') {
        this.openModal();
      } else {
        this.$router.push(Flw);
      }
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
      }
    },
    scoreStatusText(val) {
      //input lang to return text
      if (this.lang == 'TH') {
        return `*คุณได้ทำแบบทดสอบนี้ไปแล้ว และคะแนนการทำครั้งแรกของคุณคือ  ${val.previousScore}/${val.maxscore}`;
      } else {
        return `*You’ve already finished this test and Your first attempt score
 is ${val.previousScore}/${val.maxscore}`;
      }
    },
  },
};
</script>

<style>
.wordCustom {
  color: white;
}
</style>
